<template>
  <div class="goal-content page-card-wrapper">
    <div class="page-card-title">
      <span class="page-card-title-text">{{ $t('text.falls_detection') }}</span>
    </div>
    <div class="page-card-content">
      <div class="mt-30 page-content">
        <div class="light-blue-font mb-30">{{ $t('text.detect_falls') }}</div>
        <div class="slider-wrapper h-100">
          <span
            v-if="value"
            class="value-text light-blue-font"
            :style="{ left: (value / this.max) * 100 + '%' }"
            >{{ $t('text.on').toUpperCase() }}</span
          >
          <el-slider
            v-model="value"
            :min="min"
            :max="max"
            :show-tooltip="false"
          >
          </el-slider>
          <div class="min-value light-blue-font">{{ $t('text.off') }}</div>
          <div class="max-value light-blue-font">
            {{ $t('text.on').toUpperCase() }}
          </div>
        </div>
        <div class="text-right mt-10">
          <b-button variant="outline-primary" class="mr-25 visibile-hide">{{
            $t('text.default').toUpperCase()
          }}</b-button>
          <el-button
            type="success"
            plain
            class="common-btn"
            :loading="saveLoading"
            :disabled="saveLoading"
            @click="save()"
            v-if="p('Patients.Goals Module.Fall.Save')"
            >{{ $t('text.save').toUpperCase() }}</el-button
          >
        </div>
        <div
          class="mt-30"
          v-if="value === max && p('Patients.Goals Module.Position.View')"
        >
          <div class="h-center">
            <img class="mr-10" src="@/assets/image/yellow-warn.svg" />
            <span class="alert-text">
              <span
                class="blue-font pointer underline"
                @click="toPositionGoalPage()"
                >{{
                  $t('text.position_goal')
                    .charAt(0)
                    .toUpperCase() +
                    $t('text.position_goal')
                      .slice(1)
                      .toLowerCase()
                }}</span
              >
              <span class="dark-grey-font ml-3">{{
                $t('text.has_been_turn_on')
              }}</span>
            </span>
          </div>
          <!-- <div class="h-center alert-text">
            <img
              class="mr-10"
              style="visibility: hidden"
              src="@/assets/image/yellow-warn.svg"
            />
            <span class="dark-grey-font">{{ $t('text.attach_the_pod') }}</span>
          </div> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ApiService from '@/services/ApiService.js'
import swal from 'sweetalert'
import moment from 'moment'
export default {
  data() {
    return {
      moment,
      userLang: navigator.language || navigator.userLanguage,
      value: 0,
      min: 0,
      max: 1,
      lastFallDate: '',
      lastFallDateAgo: 0,
      goal: {},
      saveLoading: false
    }
  },
  watch: {
    '$store.state.patient.selectedPatientGoal': function() {
      this.getInitVal()
    }
  },
  mounted() {
    this.$store.dispatch('patient/getSelectedPatientGoal')
    this.getInitVal()
  },
  methods: {
    getInitVal() {
      this.goal = this.$store.state.patient.selectedPatientGoal
      this.value = this.goal.IsFallGoalEnabled ? 1 : 0
    },
    toPositionGoalPage() {
      this.$router.push({
        path: '/patients/position-goal'
      })
    },
    save() {
      if (!this.$store.state.patient.selectedPatient) return false
      let params = {
        patientId: this.$store.state.patient.selectedPatient.patientId,
        IsFallGoalEnabled: !!this.value
      }
      this.saveLoading = true
      ApiService.SaveFallGoal(params)
        .then(response => {
          this.saveLoading = false
          if (response.data.success) {
            this.$store.dispatch('patient/getSelectedPatientGoal')
            swal({
              icon: 'success',
              timer: 2000,
              title: this.$t('text.saved_successfully')
            })
          } else {
            swal({
              icon: 'error',
              timer: 2000,
              title: this.$t('text.saved_failed'),
              text: response.data.msg
            })
          }
        })
        .catch(() => {
          this.saveLoading = false
          swal({
            icon: 'error',
            timer: 2000,
            title: this.$t('text.saved_failed')
          })
        })
    }
  }
}
</script>
